import { useCurrentStateAndParams, useRouter } from "@uirouter/react";
import { ArrowBackIcon } from "@chakra-ui/icons";
import { Button, Flex } from "@chakra-ui/react";
import Page from "../../shared/components/Page";
import { PayerId } from "../../shared/schema/schema";
import HhaxPocMappingTable from "./HhaxPocMappingTable";

/**
 * The payer-scoped entry point, opened from the payer settings modal. The payer comes from the
 * route, so the screen shows that payer's mapping only.
 */
export default function PayerHhaxPocMappingRoute() {
  const { params } = useCurrentStateAndParams();
  const { stateService } = useRouter();

  const payerId = Number(params.payerId) as PayerId;

  return (
    <Page>
      <Page.Header>
        <Flex alignItems="center" gap={3}>
          <Button
            leftIcon={<ArrowBackIcon />}
            size="sm"
            variant="ghost"
            onClick={() => stateService.go("app.settings")}
          >
            Back to settings
          </Button>
          <Page.Title>HHAeXchange POC Mapping</Page.Title>
        </Flex>
      </Page.Header>

      <Page.Content>
        <HhaxPocMappingTable payerId={payerId} />
      </Page.Content>
    </Page>
  );
}
